import http from "../../utils/httpClient"

class billService {
    getBillList = async (query) => {
        return await http.get("/api/PurchaseOrder/GetBill", { params: query })
    }
    
    getReturnBillList = async (query) => {
        return await http.get("/api/PurchaseOrder/GetReturnBill", { params: query })
    }
}

export default new billService()